import { render } from "./EditClassification.vue?vue&type=template&id=26481998&scoped=true"
import script from "./EditClassification.vue?vue&type=script&lang=js"
export * from "./EditClassification.vue?vue&type=script&lang=js"

import "./EditClassification.vue?vue&type=style&index=0&id=26481998&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26481998"]])

export default __exports__